export default __webpack_public_path__ + "static/media/privatecar-banner.111d2d15.png";